import { FC, useContext } from "react";
import { BreakPointContext } from "../../../../context/BreakPointContext";
import { UserVisitControl } from "../../../../../domain/control/Visit";
import { VisitControlList } from "../../../data-display/visit-control-list";
import { VisitControlTable } from "../../../data-display/visit-control-table";

type Props = {
  visitControlList?: UserVisitControl[];
  onSelect: (item: UserVisitControl) => void;
};

export const UnityVisitControlDataName = "UnityVisitControlData";

export const UnityVisitControlData: FC<Props> = ({
  visitControlList,
  onSelect,
}) => {
  const screenSize = useContext(BreakPointContext);
  if (screenSize.isMobile) {
    return (
      <VisitControlList
        name={UnityVisitControlDataName}
        onSelect={onSelect}
        visitControlList={visitControlList}
      />
    );
  } else {
    return (
      <VisitControlTable
        name={UnityVisitControlDataName}
        visitControlList={visitControlList}
        onSelect={onSelect}
      />
    );
  }
};
